export const clientDefaultConfig = {
  _dependencies: ['@hey-api/typescript'],
  _tags: ['client'],
  baseUrl: true,
  bundle: false,
  exportFromIndex: false,
  output: 'client',
} as const;
